<template>
    <div>
      <search :p_searchType="d_searchType"></search>
    </div>
</template>

<script>

import { ClsUser } from '@/wam/modules/user';
import { ServiceFunctions } from '@/wam/modules/service';
import store from '@/store';
import auth from '@/auth';

import {
  default as Search
} from '@/wam/components/widgets/Search';

export default {
  name: 'search_page',
  components: {
    Search
  },
  data () {
    return {
      d_fullScreen: true,
      d_searchType: ''
    }
  },
  created: function () {
    if (this.$route.query.search_type) {
      this.d_searchType = this.$route.query.search_type;
    }
  }
};
</script>
